import { render, staticRenderFns } from "./AdminTaskBilling.vue?vue&type=template&id=063c6dd0"
import script from "./AdminTaskBilling.vue?vue&type=script&lang=js"
export * from "./AdminTaskBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports